import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import QRCodeStyling from "qr-code-styling";
import axios from "axios";
import "./DonateUs.css";

const DonateUs = () => {
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [paymentInitiated, setPaymentInitiated] = useState(false);
  const [donorName, setDonorName] = useState("");
  const [donorEmail, setDonorEmail] = useState("");
  const [donorPhone, setDonorPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const qrRef = useRef(null);
  const isMobileDevice = () => {
  return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(
    window.navigator.userAgent
  );
};

  const handleAmountChange = (e) => {
    const value = e.target.value;

    // Allow only digits
    if (/^\d*$/.test(value)) {
      // Convert to number
      const numericValue = Number(value);

      // Check if greater than 0
      if (numericValue > 0) {
        setAmount(value);
        setError("");
      } else {
        setAmount(value);
        setError("Amount must be greater than 0.");
      }
    } else {
      setError("Amount must be a number.");
    }
  };

  const upiID = "8345040440-1@okbizaxis";

  const generateUPIString = () => {
    const numAmount = Number(amount);
    if (!amount || numAmount <= 0) {
      return null;
    }
    // UPI string format for QR code
    return `upi://pay?pa=${upiID}&pn=Mallabhum%20Prayas&am=${numAmount}&cu=INR`;
  };

  // Generate QR code when amount changes
  useEffect(() => {
    const numAmount = Number(amount);
    if (amount && numAmount > 0 && qrRef.current) {
      // Clear previous QR codes
      qrRef.current.innerHTML = "";
      
      const upiString = `upi://pay?pa=${upiID}&pn=Mallabhum%20Prayas&am=${numAmount}&cu=INR`;
      const qrCode = new QRCodeStyling({
        width: 250,
        height: 250,
        data: upiString,
        margin: 10,
        dotsOptions: {
          color: "#000000",
          type: "square",
        },
        backgroundOptions: {
          color: "#ffffff",
        },
      });
      qrCode.append(qrRef.current);
    }
  }, [amount, upiID]);

  const handleDownloadQR = () => {
    const qrCode = new QRCodeStyling({
      width: 300,
      height: 300,
      data: generateUPIString(),
      margin: 10,
    });
    qrCode.download({
      name: `Mallabhum-Prayas-${amount}`,
      extension: "png",
    });
  };

  const handleOpenUPIApp = () => {
    const numAmount = Number(amount);
    if (!amount || numAmount <= 0) {
      setError("Please enter a valid amount greater than 0.");
      return;
    }
    
    const upiLink = `upi://pay?pa=${upiID}&pn=Mallabhum%20Prayas&am=${numAmount}&cu=INR`;
    setPaymentInitiated(true);
    window.location.href = upiLink;
  };

  const handleSubmitDonorInfo = async () => {
    if (!donorName.trim()) {
      alert("Please enter your name");
      return;
    }

    setLoading(true);

    const donorData = {
      name: donorName,
      email: donorEmail,
      phone: donorPhone,
      amount: Number(amount),
      date: new Date().toISOString(),
      upiId: upiID,
    };

    try {
      // API call to backend
      const response = await axios.post(
        "http://localhost:5000/api/donations", // Update with your backend URL
        donorData
      );

      if (response.status === 201 || response.status === 200) {
        // Success message
        alert(
          `Thank you, ${donorName}! 💖\n\nYour donation of ₹${amount} has been recorded.\nReceipt sent to ${
            donorEmail || "your email"
          }\n\nTransaction ID: ${response.data?.id || "MP-" + Date.now()}`
        );

        console.log("Donation submitted successfully:", response.data);
        resetModal();
      }
    } catch (err) {
      console.error("Error submitting donation:", err);
      alert(
        `Thank you for your donation! ₹${amount}\n\nNote: We couldn't record your details.\nPlease contact us at info@mallabhumprayas.org`
      );
      resetModal();
    } finally {
      setLoading(false);
    }
  };

  const resetModal = () => {
    setShowModal(false);
    setPaymentInitiated(false);
    setAmount("");
    setDonorName("");
    setDonorEmail("");
    setDonorPhone("");
    setError("");
  };

  return (
    <div className="donate-us-container container-fluid d-flex align-items-center justify-content-center">
      <div className="row text-center">
        {/* Google Pay QR Code Section */}
        <div className="col-md-6 qr-code-container">
          <h2>💖 Support Us</h2>
          <p>
            Every little bit counts! Your support allows us to continue our
            mission and reach more people in need.
          </p>
          <h5>Donate via Google Pay</h5>
          <a
            href="/assets/img/m-donate/Mallabhum-213x300.png"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/img/m-donate/Mallabhum-213x300.png"
              alt="Donate with Google Pay"
              className="gpay-image"
            />
          </a>
        </div>

        {/* Account Details Section */}
        <div className="col-md-6 account-details text-left">
          <h6>Account Details: 📋</h6>
          <p>
            <strong>🏦A/C Holder Name:</strong> Mallabhum Prayas
          </p>
          <p>
            <strong>💳A/C No.:</strong> 426210110014514 (BOI)
          </p>
          <p>
            <strong>🔑IFSC Code:</strong> BKID0004262
          </p>

          {/* Pay Online Button */}
          <button
            className="btn btn-success mt-3"
            onClick={() => setShowModal(true)}
          >
            💸 Pay Now
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">🧾 Donate Now</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={resetModal}
                ></button>
              </div>
              <div className="modal-body">
                {paymentInitiated ? (
                  <div>
                    <div className="alert alert-success text-center mb-4">
                      <h5>✅ Payment Initiated!</h5>
                      <p>Your UPI app is opening...</p>
                      <p className="mb-0"><strong>Thank you for your support! 💖</strong></p>
                    </div>

                    <h6 className="mb-3">📝 Please provide your details for receipt:</h6>
                    
                    <div className="mb-3">
                      <label htmlFor="donorName" className="form-label">Your Name *</label>
                      <input
                        type="text"
                        id="donorName"
                        className="form-control"
                        value={donorName}
                        onChange={(e) => setDonorName(e.target.value)}
                        placeholder="e.g. John Doe"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="donorEmail" className="form-label">Email Address</label>
                      <input
                        type="email"
                        id="donorEmail"
                        className="form-control"
                        value={donorEmail}
                        onChange={(e) => setDonorEmail(e.target.value)}
                        placeholder="your@email.com"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="donorPhone" className="form-label">Phone Number</label>
                      <input
                        type="tel"
                        id="donorPhone"
                        className="form-control"
                        value={donorPhone}
                        onChange={(e) => setDonorPhone(e.target.value)}
                        placeholder="9876543210"
                      />
                    </div>

                    <small className="text-muted">Your information helps us send you a donation receipt and keep you updated about our impact.</small>
                  </div>
                ) : (
                  <>
                    <p>
                      <strong>Account Name:</strong> Mallabhum Prayas
                    </p>
                    <label htmlFor="amount">Enter Amount (₹):</label>
                    <input
                      type="number"
                      id="amount"
                      className="form-control my-2"
                      value={amount}
                      onChange={handleAmountChange}
                      placeholder="e.g. 100"
                      min="1"
                      required
                    />
                    {error && <div className="text-danger small">{error}</div>}

                    {/* QR Code Display */}
                    {generateUPIString() && (
                      <div className="text-center mt-4">
                        <p className="text-muted"><strong>📱 Scan with any UPI app:</strong></p>
                        <div 
                          ref={qrRef} 
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "10px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            marginBottom: "10px"
                          }}
                        />
                        <small className="text-muted">Use Google Pay, PhonePe, Paytm or any UPI app</small>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={resetModal}
                >
                  ❌ Cancel
                </button>
                {paymentInitiated && (
                  <button
                    className="btn btn-success"
                    onClick={handleSubmitDonorInfo}
                    disabled={loading}
                  >
                    {loading ? "⏳ Submitting..." : "✅ Confirm & Submit"}
                  </button>
                )}
                {!paymentInitiated && isMobileDevice() && generateUPIString() && (
                  <button
                    className="btn btn-success"
                    onClick={handleOpenUPIApp}
                  >
                    🏦 Open UPI App
                  </button>
                )}
                {!paymentInitiated && generateUPIString() && (
                  <button
                    className="btn btn-primary"
                    onClick={handleDownloadQR}
                  >
                    📥 Download QR
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DonateUs;
